export const COLORS = ["#4BB568", "#008267", "#40e66e", "#005745"]; // Add here colors if the pie contains more than 3 values
